import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

const FirmanteComponent = ({ data }) => {
  useEffect(() => {
    console.log(data);
  }, [
    data
  ])

  return (
    <Fragment>
      <div className="row">
        <div className="col-sm-12 d-flex mb-4">
          <div className="d-inline font-family-poppins-medium fs-16 fw-bold text-dark">
            Tipo de firmante:
          </div>
          <div className="d-inline font-family-poppins-medium fs-16 fw-normal ml-4 text-dark-light">
            { data.contacto_tipo }
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            Fecha:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            { data.date }
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            Firmante:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            { data.full_name }
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            Email:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            { data.email }
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            Teléfono:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            { data.phone }
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            Teléfono:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            { data.phone }
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            Tipo de documento:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            { data.dni_tipo }
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            Foto perfil:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            <img className="img-responsive" src={data.photo_profile} alt='' />
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            Foto frontal:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            <img className="img-responsive" src={data.photo_dni_front} alt='' />
          </div>
        </div>
        { data.dni_tipo !== 'Pasaporte' &&  (
          <Fragment>
            <div className="col-sm-12 mb-4">
              <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
                Foto reverso:
              </div>
            </div>
            <div className="col-sm-12 mb-4">
              <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
                <img className="img-responsive" src={data.photo_dni_front_reverse} alt='' />
              </div>
            </div>
          </Fragment>
        )}
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            Firma contrato:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            <img className="img-responsive" src={data.photo_contract} alt='' />
          </div>
        </div>
        {(data.contacto_tipo !== 'Propietario Fisico' && data.contacto_tipo !== 'Propietario Moral') && (
          <Fragment>
            <div className="col-sm-12 mb-4">
              <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
                Firma pagaré:
              </div>
            </div>
            <div className="col-sm-12 mb-4">
              <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
                <img className="img-responsive" src={data.photo_pagare} alt='' />
              </div>
            </div>
          </Fragment>
        )}
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            MAC:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            { data.mac }
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-bold text-dark">
            Ip:
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="font-family-poppins-medium fs-16 fw-normal text-dark-light">
            { data.ip }
          </div>
        </div>
        <div className="col-sm-12 mb-4">
          <div className="border-line"></div>
        </div>
      </div>
    </Fragment>
  );
};

FirmanteComponent.propTypes = {
  data: PropTypes.any.isRequired
}

export default FirmanteComponent;